const ViewFileManager = () => {
  return <div>ViewFileManager</div>;
};

export default ViewFileManager;
